(function(){
  var dataEl=document.getElementById('bb-data');
  if(!dataEl)return;
  var D=JSON.parse(dataEl.textContent);
  var wrap=document.querySelector('.bb-wrap');
  var qs=new URLSearchParams(location.search);
  var UI=qs.get('bb_ui')||wrap.getAttribute('data-color-ui')||'swatch';
  var LIVE_MODE=qs.get('bb_live')||wrap.getAttribute('data-live-media')||'fallback';
  var COLORS_OPEN_DEFAULT=wrap.getAttribute('data-colors-open')==='1';
  var STICKY=wrap.getAttribute('data-sticky')==='1';

  var galEl=document.getElementById('bb-gallery');
  var galTrack=document.getElementById('bb-gal-track');
  var galThumbs=document.getElementById('bb-gal-thumbs');
  var galDots=document.getElementById('bb-gal-dots');
  var tiersEl=document.getElementById('bb-tiers');
  var slotsEl=document.getElementById('bb-slots');
  var slotsHead=document.querySelector('.bb-slots-head');
  var slotCountEl=document.getElementById('bb-slotcount');
  var mediaEl=document.getElementById('bb-media-live');
  var priceEl=document.getElementById('bb-price');
  var compareEl=document.getElementById('bb-compare');
  var pctEl=document.getElementById('bb-pct');
  var unitEl=document.getElementById('bb-unit');
  var saveEl=document.getElementById('bb-save');
  var shipEl=document.getElementById('bb-ship');
  var addBtn=document.getElementById('bb-add');
  var msgEl=document.getElementById('bb-msg');
  var stickyEl=document.getElementById('bb-sticky');
  var stickySel=document.getElementById('bb-sticky-sel');
  var stickyPrice=document.getElementById('bb-sticky-price');
  var stickyImg=document.getElementById('bb-sticky-img');
  var stickyAdd=document.getElementById('bb-sticky-add');
  var stickyEdit=document.getElementById('bb-sticky-edit');

  var media=Array.isArray(D.media)?D.media:[];
  var showLive=LIVE_MODE==='always'||(LIVE_MODE==='fallback'&&media.length===0);
  var tiers=Array.isArray(D.tiers)?D.tiers:[];
  var multipack=D.pools.length===1&&tiers.length>0;
  var slots=[],openColors={},tierIdx=0,galIdx=0;

  function money(c){return '₺'+(c/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2});}
  var QTY_SUFFIX={2:"'li",3:"'lü",4:"'lü",5:"'li",6:"'lı",7:"'li",8:"'li",9:"'lu",10:"'lu",12:"'li"};
  function qtyLabel(n){return n+(QTY_SUFFIX[n]||"'li");}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');}

  function track(ev,params){
    var p=params||{};
    try{if(window.gtag){window.gtag('event',ev,p);}else if(window.dataLayer){var o={event:ev};for(var k in p){o[k]=p[k];}window.dataLayer.push(o);}}catch(e){}
    try{if(window.fbq){window.fbq('trackCustom',ev,p);}}catch(e){}
    try{if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish){window.Shopify.analytics.publish(ev,p);}}catch(e){}
  }

  function setX(pct,animate){
    galTrack.style.transition=animate?'':'none';
    galTrack.style.transform='translateX('+pct+'%)';
    if(!animate){void galTrack.offsetHeight;galTrack.style.transition='';}
  }
  function showSlide(i,animate){
    if(!media.length)return;
    galIdx=(i+media.length)%media.length;
    setX(-galIdx*100,animate!==false);
    [].forEach.call(galThumbs.children,function(el,n){el.classList.toggle('on',n===galIdx);});
    [].forEach.call(galDots.children,function(el,n){el.classList.toggle('on',n===galIdx);});
  }
  function initGallery(){
    if(!media.length){galEl.hidden=true;return;}
    galEl.hidden=false;
    galEl.setAttribute('data-many',media.length>1?'1':'0');
    galTrack.innerHTML=media.map(function(m,i){
      var load=i===0?'loading="eager" fetchpriority="high"':'loading="lazy"';
      return '<img src="'+m.u+'" alt="'+esc(m.a||D.title)+'" '+load+' decoding="async" draggable="false">';
    }).join('');
    galThumbs.innerHTML=media.length>1?media.map(function(m,i){return '<img src="'+m.t+'" alt="" data-i="'+i+'" loading="lazy">';}).join(''):'';
    galDots.innerHTML=media.length>1?media.map(function(){return '<i></i>';}).join(''):'';
    galThumbs.addEventListener('click',function(ev){
      var t=ev.target.closest('img[data-i]');
      if(t)showSlide(parseInt(t.getAttribute('data-i'),10));
    });
    galEl.querySelector('.bb-gal-prev').addEventListener('click',function(){showSlide(galIdx-1);});
    galEl.querySelector('.bb-gal-next').addEventListener('click',function(){showSlide(galIdx+1);});
    var stage=galEl.querySelector('.bb-gal-stage'),x0=null,dragging=false,w=1;
    stage.addEventListener('touchstart',function(e){if(media.length<2)return;x0=e.changedTouches[0].clientX;dragging=true;w=stage.clientWidth||1;},{passive:true});
    stage.addEventListener('touchmove',function(e){if(!dragging)return;setX(-galIdx*100+((e.changedTouches[0].clientX-x0)/w)*100,false);},{passive:true});
    stage.addEventListener('touchend',function(e){
      if(!dragging)return;
      dragging=false;
      var dx=e.changedTouches[0].clientX-x0;
      if(Math.abs(dx)>w*0.15)showSlide(galIdx+(dx<0?1:-1));else showSlide(galIdx);
      x0=null;
    },{passive:true});
    showSlide(0,false);
  }

  function poolOf(s){return D.pools[s.poolIdx];}
  function productOf(s){
    var ps=poolOf(s).products;
    for(var i=0;i<ps.length;i++){if(ps[i].id===s.productId)return ps[i];}
    return ps[0];
  }
  function colorLabel(p){
    if(p.colorIdx>=0&&p.variants.length)return p.variants[0].opts[p.colorIdx];
    var parts=p.title.split('|');
    return parts.length>1?parts[parts.length-1].trim():p.title;
  }
  function familyWords(p){
    var parts=p.title.split('|');
    var fam=parts.length>1?parts[0].trim():p.title;
    return fam.split(/\s+/).filter(Boolean);
  }
  function buildLabels(pool){
    var sets=pool.products.map(familyWords);
    var common=sets.length?sets[0].filter(function(w){return sets.every(function(ws){return ws.indexOf(w)!==-1;});}):[];
    var seen={},dupe={};
    pool.products.forEach(function(p){var c=colorLabel(p);if(seen[c])dupe[c]=true;seen[c]=true;});
    pool.products.forEach(function(p,i){
      var c=colorLabel(p);
      if(dupe[c]){
        var extra=sets[i].filter(function(w){return common.indexOf(w)===-1;}).join(' ');
        p.label=extra?(c+' · '+extra):c;
      }else{p.label=c;}
    });
  }
  function labelOf(p){return p.label||colorLabel(p);}

  function findVariant(p,opts){
    for(var i=0;i<p.variants.length;i++){
      var v=p.variants[i],ok=true;
      for(var j=0;j<opts.length;j++){if(v.opts[j]!==opts[j]){ok=false;break;}}
      if(ok)return v;
    }
    return null;
  }
  function defaultOpts(p){
    for(var i=0;i<p.variants.length;i++){if(p.variants[i].avail)return p.variants[i].opts.slice();}
    return p.variants.length?p.variants[0].opts.slice():[];
  }
  function optionValues(p,oi){
    var vals=[];
    for(var i=0;i<p.variants.length;i++){var val=p.variants[i].opts[oi];if(vals.indexOf(val)===-1)vals.push(val);}
    return vals;
  }
  function valAvailable(p,oi,val,opts){
    for(var i=0;i<p.variants.length;i++){
      var v=p.variants[i];
      if(!v.avail||v.opts[oi]!==val)continue;
      var ok=true;
      for(var j=0;j<p.optNames.length;j++){
        if(j===oi)continue;
        if(opts[j]&&v.opts[j]!==opts[j]){ok=false;break;}
      }
      if(ok)return true;
    }
    return false;
  }
  function currentTier(){return multipack?(tiers[tierIdx]||{qty:slots.length,pct:0}):(tiers[0]||{qty:D.pools.length,pct:0});}
  function isFixed(t){return t&&typeof t.price==='number';}
  function tierFinal(t,sum,prices){
    if(isFixed(t))return t.price;
    if(t&&t.free){
      var arr=(prices||[]).slice().sort(function(a,b){return a-b;});
      var off=0;
      for(var i=0;i<t.free&&i<arr.length;i++)off+=arr[i];
      return sum-off;
    }
    return Math.round(sum*(100-((t&&t.pct)||0))/100);
  }
  function tierTitle(t){
    if(t.label)return t.label;
    if(t.free)return t.qty+' AL '+(t.qty-t.free)+' ÖDE';
    return qtyLabel(t.qty);
  }
  function tierSub(t){
    if(isFixed(t))return money(t.price);
    if(t.free)return t.free+' parça bedava';
    return t.pct?('%'+t.pct+' indirim'):'tek fiyat';
  }

  function buildSlots(){
    var t=currentTier();
    var count=multipack?t.qty:D.pools.length;
    var next=[];
    for(var i=0;i<count;i++){
      var poolIdx=multipack?0:i;
      if(slots[i]&&slots[i].poolIdx===poolIdx){next.push(slots[i]);continue;}
      var pool=D.pools[poolIdx];
      if(!pool||!pool.products.length)continue;
      var p=pool.products[Math.min(i,pool.products.length-1)]||pool.products[0];
      next.push({poolIdx:poolIdx,productId:p.id,opts:defaultOpts(p)});
    }
    slots=next;
  }

  function renderTiers(){
    if(!multipack||tiers.length<2){tiersEl.hidden=true;return;}
    tiersEl.hidden=false;
    tiersEl.innerHTML=tiers.map(function(t,i){
      var cls='bb-tier'+(i===tierIdx?' sel':'');
      return '<button type="button" class="'+cls+'" data-tier="'+i+'"><b>'+esc(tierTitle(t))+'</b><small>'+esc(tierSub(t))+'</small></button>';
    }).join('');
  }

  function colorPicker(pool,s,si){
    if(pool.products.length<2)return '';
    if(UI==='dropdown'){
      var opts=pool.products.map(function(pp){
        return '<option value="'+pp.id+'"'+(pp.id===s.productId?' selected':'')+'>'+esc(labelOf(pp))+'</option>';
      }).join('');
      return '<div class="bb-optname">RENK / MODEL</div><select class="bb-select" data-role="product">'+opts+'</select>';
    }
    var body;
    if(UI==='swatch'){
      body='<div class="bb-swatches" data-role="product">'+pool.products.map(function(pp){
        var cls='bb-sw'+(pp.id===s.productId?' sel':'');
        return '<button type="button" class="'+cls+'" data-pid="'+pp.id+'" title="'+esc(labelOf(pp))+'"><img src="'+(pp.img||'')+'" alt="'+esc(labelOf(pp))+'" width="44" height="44" loading="lazy"></button>';
      }).join('')+'</div>';
    }else{
      body='<div class="bb-vals" data-role="product">'+pool.products.map(function(pp){
        var cls='bb-val'+(pp.id===s.productId?' sel':'');
        return '<button type="button" class="'+cls+'" data-pid="'+pp.id+'">'+esc(labelOf(pp))+'</button>';
      }).join('')+'</div>';
    }
    return '<div class="bb-disc"'+(openColors[si]?' open':'')+' data-disc="'+si+'">'+
           '<button type="button" class="bb-disc-head" data-toggle="'+si+'">'+
           '<b>RENK / MODEL</b><span class="bb-disc-act">Seçimi değiştir<i class="bb-chev"></i></span>'+
           '</button><div class="bb-disc-body">'+body+'</div></div>';
  }

  function renderSlots(){
    slotCountEl.textContent=slots.length+' ürün';
    var html='';
    slots.forEach(function(s,si){
      var pool=poolOf(s),p=productOf(s),v=findVariant(p,s.opts);
      var pdp=' href="'+p.url+'" target="_blank" rel="noopener" data-comp="'+esc(p.url.split('/').pop())+'"';
      html+='<div class="bb-slot" data-si="'+si+'">';
      html+='<a'+pdp+' aria-label="'+esc(p.title)+'"><img class="bb-slot-img" src="'+(p.imgLg||p.img||'')+'" alt=""></a>';
      html+='<div><div class="bb-slot-no">'+(si+1)+'. ÜRÜN</div>';
      html+='<div class="bb-slot-title"><a'+pdp+'>'+esc(p.title)+'</a></div>';
      html+=colorPicker(pool,s,si);
      p.optNames.forEach(function(on,oi){
        if(oi===p.colorIdx&&pool.products.length>1)return;
        if(slots.length>1){
          html+='<div class="bb-optrow"><div class="bb-optname">'+esc(on)+'</div>'+
                '<button type="button" class="bb-applyall" data-si="'+si+'" data-oi="'+oi+'">Tümüne uygula</button></div>';
        }else{
          html+='<div class="bb-optname">'+esc(on)+'</div>';
        }
        html+='<div class="bb-vals" data-role="opt" data-oi="'+oi+'">';
        optionValues(p,oi).forEach(function(val){
          var cls='bb-val'+(s.opts[oi]===val?' sel':'')+(valAvailable(p,oi,val,s.opts)?'':' ko');
          html+='<button type="button" class="'+cls+'" data-val="'+esc(val)+'">'+esc(val)+'</button>';
        });
        html+='</div>';
      });
      if(!v||!v.avail){html+='<div class="bb-optname" style="color:#c62828">Bu seçim stokta yok</div>';}
      html+='</div></div>';
    });
    slotsEl.innerHTML=html;
  }

  function renderMedia(){
    if(!mediaEl)return;
    if(!showLive){mediaEl.innerHTML='';mediaEl.removeAttribute('data-n');return;}
    mediaEl.setAttribute('data-n',String(slots.length));
    mediaEl.innerHTML=slots.map(function(s){
      var p=productOf(s);
      return '<figure><a href="'+p.url+'" target="_blank" rel="noopener" data-comp="'+esc(p.url.split('/').pop())+'"><img src="'+(p.imgLg||p.img||'')+'" alt="'+esc(p.title)+'" loading="eager" decoding="async"></a><figcaption>'+esc(labelOf(p))+'</figcaption></figure>';
    }).join('');
  }

  function totals(){
    var sum=0,ok=slots.length>0,prices=[];
    slots.forEach(function(s){
      var v=findVariant(productOf(s),s.opts);
      if(v&&v.avail){sum+=v.price;prices.push(v.price);}else{ok=false;}
    });
    return {sum:sum,ok:ok,prices:prices};
  }

  function selectionSummary(){
    return slots.map(function(s){
      var p=productOf(s),sizeIdx=-1;
      p.optNames.forEach(function(on,oi){if(oi!==p.colorIdx&&sizeIdx<0)sizeIdx=oi;});
      return labelOf(p)+(sizeIdx>=0?(' '+s.opts[sizeIdx]):'');
    }).join(', ');
  }

  function renderSticky(fin,ok){
    if(!stickyEl)return;
    var t=currentTier();
    stickyPrice.textContent=money(fin);
    stickySel.textContent=tierTitle(t)+' · '+selectionSummary();
    var p0=slots.length?productOf(slots[0]):null;
    if(p0)stickyImg.src=p0.imgLg||p0.img||'';
    stickyAdd.disabled=!ok;
  }

  function renderPrice(){
    var t=currentTier(),r=totals();
    var fin=tierFinal(t,r.sum,r.prices),diff=r.sum-fin;
    priceEl.textContent=money(fin);
    if(diff>0&&r.sum>0){
      compareEl.textContent=money(r.sum);
      pctEl.textContent='-%'+Math.round(diff/r.sum*100);
      pctEl.hidden=false;
      saveEl.textContent='Kazancınız: '+money(diff);
      saveEl.hidden=false;
    }else{
      compareEl.textContent='';pctEl.hidden=true;saveEl.hidden=true;
    }
    unitEl.textContent=slots.length>1?(money(Math.round(fin/slots.length))+' / ürün'):'';
    if(t.ship){shipEl.hidden=false;shipEl.textContent='Bu pakette kargo bizden.';}else{shipEl.hidden=true;}
    addBtn.disabled=!r.ok;
    msgEl.textContent=r.ok?'':'Stokta olmayan bir seçim var, lütfen değiştirin.';
    renderSticky(fin,r.ok);
  }

  function render(){renderTiers();renderSlots();renderMedia();renderPrice();evalSticky();}

  function pickProduct(s,si,newId){
    if(newId===s.productId)return;
    var prevOpts=s.opts.slice();
    s.productId=newId;
    var np=productOf(s);
    s.opts=defaultOpts(np);
    np.optNames.forEach(function(on,oi){
      if(oi===np.colorIdx)return;
      if(prevOpts[oi]&&valAvailable(np,oi,prevOpts[oi],s.opts))s.opts[oi]=prevOpts[oi];
    });
    render();
    track('bundle_slot_select',{bundle_id:D.handle,slot_index:si+1,product_handle:np.url.split('/').pop(),color:labelOf(np),options:s.opts.join(' / ')});
  }

  tiersEl.addEventListener('click',function(ev){
    var btn=ev.target.closest('.bb-tier');
    if(!btn)return;
    tierIdx=parseInt(btn.getAttribute('data-tier'),10);
    buildSlots();
    slots.forEach(function(s,i){if(openColors[i]===undefined)openColors[i]=COLORS_OPEN_DEFAULT;});
    render();
    var t=currentTier();
    track('bundle_tier_select',{bundle_id:D.handle,tier:t.qty,discount_pct:t.pct||0});
  });

  slotsEl.addEventListener('change',function(ev){
    var sel=ev.target.closest('select[data-role="product"]');
    if(!sel)return;
    var si=parseInt(sel.closest('.bb-slot').getAttribute('data-si'),10);
    pickProduct(slots[si],si,parseInt(sel.value,10));
  });

  function compClick(ev){
    var a=ev.target.closest('a[data-comp]');
    if(a)track('bundle_component_click',{bundle_id:D.handle,product_handle:a.getAttribute('data-comp')});
  }
  slotsEl.addEventListener('click',compClick);
  if(mediaEl)mediaEl.addEventListener('click',compClick);

  slotsEl.addEventListener('click',function(ev){
    if(ev.target.closest('a[data-comp]'))return;
    var apply=ev.target.closest('.bb-applyall');
    if(apply){
      var asi=parseInt(apply.getAttribute('data-si'),10);
      var aoi=parseInt(apply.getAttribute('data-oi'),10);
      var src=slots[asi],sp=productOf(src);
      var oname=sp.optNames[aoi],oval=src.opts[aoi],applied=0;
      slots.forEach(function(s2,i2){
        if(i2===asi)return;
        var p2=productOf(s2),j=p2.optNames.indexOf(oname);
        if(j<0)return;
        if(valAvailable(p2,j,oval,s2.opts)){s2.opts[j]=oval;applied++;}
      });
      render();
      msgEl.textContent=applied===slots.length-1?'':'Bir üründe bu seçenek stokta yok, o değiştirilmedi.';
      track('bundle_apply_all',{bundle_id:D.handle,option:oname,value:oval,applied:applied});
      return;
    }
    var head=ev.target.closest('.bb-disc-head');
    if(head){
      var di=parseInt(head.getAttribute('data-toggle'),10);
      openColors[di]=!openColors[di];
      var disc=head.parentElement;
      if(openColors[di])disc.setAttribute('open','');else disc.removeAttribute('open');
      evalSticky();
      track('bundle_colors_toggle',{bundle_id:D.handle,slot_index:di+1,open:!!openColors[di]});
      return;
    }
    var swBtn=ev.target.closest('.bb-sw');
    if(swBtn){
      var siS=parseInt(swBtn.closest('.bb-slot').getAttribute('data-si'),10);
      pickProduct(slots[siS],siS,parseInt(swBtn.getAttribute('data-pid'),10));
      return;
    }
    var btn=ev.target.closest('.bb-val');
    if(!btn)return;
    var si=parseInt(btn.closest('.bb-slot').getAttribute('data-si'),10);
    var s=slots[si];
    if(btn.parentElement.getAttribute('data-role')==='product'){
      pickProduct(s,si,parseInt(btn.getAttribute('data-pid'),10));
      return;
    }
    var oi=parseInt(btn.parentElement.getAttribute('data-oi'),10);
    s.opts[oi]=btn.getAttribute('data-val');
    render();
    var pp=productOf(s);
    track('bundle_slot_select',{bundle_id:D.handle,slot_index:si+1,product_handle:pp.url.split('/').pop(),color:labelOf(pp),options:s.opts.join(' / ')});
  });

  function setBusy(b){
    addBtn.disabled=b;
    addBtn.textContent=b?'EKLENİYOR...':'SEPETE EKLE';
    if(stickyAdd){stickyAdd.disabled=b;stickyAdd.textContent=b?'EKLENİYOR...':'SEPETE EKLE';}
  }
  function resetAddBtn(){setBusy(false);renderPrice();}
  window.addEventListener('pageshow',function(ev){if(ev.persisted)resetAddBtn();});
  document.addEventListener('visibilitychange',function(){if(!document.hidden&&addBtn.textContent!=='SEPETE EKLE')resetAddBtn();});

  function doAdd(){
    var t=currentTier();
    var items=[],ok=true,sum=0,prices=[],variantIds=[];
    slots.forEach(function(s){
      var v=findVariant(productOf(s),s.opts);
      if(v&&v.avail){
        var props={_bundle:D.handle,_bundle_tier:String(t.qty)};
        if(D.paket)props._paket=D.paket;
        items.push({id:v.id,quantity:1,properties:props});
        variantIds.push(v.id);sum+=v.price;prices.push(v.price);
      }else{ok=false;}
    });
    if(!ok||!items.length){msgEl.textContent='Lütfen her ürün için stokta olan bir seçim yapın.';return;}
    var fin=tierFinal(t,sum,prices);
    setBusy(true);
    track('bundle_add_to_cart',{bundle_id:D.handle,bundle_name:D.title,tier:t.qty,value:fin/100,currency:'TRY',item_count:items.length,variant_ids:variantIds.join(',')});
    try{if(window.gtag){window.gtag('event','add_to_cart',{currency:'TRY',value:fin/100,items:[{item_id:D.handle,item_name:D.title,item_category:'bundle',price:fin/100,quantity:1}]});}}catch(e){}
    try{if(window.fbq){window.fbq('track','AddToCart',{content_ids:[D.handle],content_type:'product',value:fin/100,currency:'TRY'});}}catch(e){}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json();})
      .then(function(){
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{bundle:D.handle,bundle_tier:String(t.qty)}})}).catch(function(){});
      })
      .then(function(){window.location.href='/cart';})
      .catch(function(){resetAddBtn();msgEl.textContent='Bir hata oluştu, tekrar deneyin.';});
  }
  addBtn.addEventListener('click',doAdd);
  if(stickyAdd)stickyAdd.addEventListener('click',doAdd);
  if(stickyEdit)stickyEdit.addEventListener('click',function(){
    if(slotsHead)slotsHead.scrollIntoView({behavior:'smooth',block:'start'});
  });

  function evalSticky(){
    if(!STICKY||!stickyEl)return;
    var vh=window.innerHeight||document.documentElement.clientHeight||0;
    if(!vh){stickyEl.hidden=true;return;}
    var r=addBtn.getBoundingClientRect();
    stickyEl.hidden=(r.top<(vh-60)&&r.bottom>0);
  }
  function initSticky(){
    if(!STICKY||!stickyEl)return;
    window.addEventListener('scroll',evalSticky,{passive:true});
    window.addEventListener('resize',evalSticky);
    evalSticky();
  }

  D.pools.forEach(buildLabels);
  if(multipack&&tiers.length>1)tierIdx=Math.min(1,tiers.length-1);
  buildSlots();
  slots.forEach(function(s,i){openColors[i]=COLORS_OPEN_DEFAULT;});
  initGallery();
  render();
  initSticky();
  var t0=currentTier();
  track('bundle_view',{bundle_id:D.handle,bundle_name:D.title,tier:t0.qty,discount_pct:t0.pct||0,ui:UI,has_media:media.length});
  try{if(window.gtag){window.gtag('event','view_item',{currency:'TRY',items:[{item_id:D.handle,item_name:D.title,item_category:'bundle'}]});}}catch(e){}
})();
